import { newE2EPage } from "@stencil/core/testing";

describe("uic-multiline-input", () => {
    it("renders common props", async () => {
        const page = await newE2EPage({
            html: `<uic-multiline-input value="my value" helper-text="my-helper-text" label="my label"></uic-multiline-input>`
        });

        const el = await page.find("uic-multiline-input");

        expect(el).toMatchSnapshot();
    });

    it("emits uicInput on keystrokes and uicChange when losing focus", async () => {
        const page = await newE2EPage({
            html: `<uic-multiline-input value="i have " helper-text="my-helper-text" label="my label"></uic-multiline-input>`
        });

        const expectedTextValue = "i have some text";

        const el = await page.find("uic-multiline-input");
        const textarea = await el.find("textarea");
        const uicInput = await el.spyOnEvent("uicInput");
        const uicChange = await el.spyOnEvent("uicChange");

        await textarea.type("some text");

        expect(await el.getProperty("value")).toEqual(expectedTextValue);
        expect(uicInput).toHaveReceivedEventTimes(9);
        expect(uicChange).toHaveReceivedEventTimes(0);

        await textarea.press("Tab");

        expect(uicInput).toHaveReceivedEventTimes(9);
        expect(uicChange).toHaveReceivedEventTimes(1);
    });
});
